import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { formatTimezoneDate } from '../../../../helpers/helpers'

const InspectionDataItem = ({ inspection }) => {
  const { t } = useTranslation(['internal-inspections'])
  return (
    <div className="inspection-data">
      {inspection.locationValue && (
        <div className="inspection-data__item">
          <span className="inspection-data__item__label">
            {t('internal-inspections:columns.location')}
          </span>
          <span className="inspection-data__item__value">{inspection.locationValue}</span>
        </div>
      )}
      {inspection.assignees && inspection.assignees.length > 0 && inspection.assignees[0].user && (
        <div className="inspection-data__item">
          <span className="inspection-data__item__label">
            {t('internal-inspections:inspectionDataItem.completedBy')}
          </span>
          <span className="inspection-data__item__value">
            {`${inspection.assignees[0].user.firstName} ${inspection.assignees[0].user.lastName}`}
          </span>
        </div>
      )}
      {inspection.date && (
        <div className="inspection-data__item">
          <span className="inspection-data__item__label">
            {t('internal-inspections:inspectionDataItem.dateScheduled')}
          </span>
          <span className="inspection-data__item__value">
            {formatTimezoneDate(inspection.date)}
          </span>
        </div>
      )}
      {inspection.startedAt && (
        <div className="inspection-data__item">
          <span className="inspection-data__item__label">
            {t('internal-inspections:inspectionDataItem.dateStarted')}
          </span>
          <span className="inspection-data__item__value">
            {formatTimezoneDate(inspection.startedAt)}
          </span>
        </div>
      )}
      {inspection.completedAt && (
        <div className="inspection-data__item">
          <span className="inspection-data__item__label">
            {t('internal-inspections:inspectionDataItem.dateCompleted')}
          </span>
          <span className="inspection-data__item__value">
            {formatTimezoneDate(inspection.completedAt)}
          </span>
        </div>
      )}
      {/*

    TODO: When the API is ready

    <button onClick={() => {}} className="button button-black">
      Download PDF
      <DownloadSimple size={18} />
    </button>

    */}
    </div>
  )
}

InspectionDataItem.propTypes = {
  inspection: PropTypes.object,
}

export default InspectionDataItem
